import { render } from "./PricingCardsSubsection.vue?vue&type=template&id=476e7bdc&ts=true"
import script from "./PricingCardsSubsection.vue?vue&type=script&lang=ts"
export * from "./PricingCardsSubsection.vue?vue&type=script&lang=ts"

import "./PricingCardsSubsection.vue?vue&type=style&index=0&id=476e7bdc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__